import { Routes, Route } from 'react-router-dom';
import { routes } from '../routes/routes';
import { Toaster } from '@/shared/components/ui/sonner';
import { ConsentRequiredModal } from '@/shared/components/ConsentRequiredModal';
import { useCrossTabLogout } from '@/shared/hooks/useCrossTabLogout';

export default function App() {
  useCrossTabLogout();

  return (
    <>
      <Routes>
        {routes.map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}
      </Routes>
      <Toaster position="top-right" />
      <ConsentRequiredModal />
    </>
  );
}
